// Horizontal offset of each tab (the sum of the widths of the previous ones,
// in the order of the tab refs), for every index from 0 to count. Computed in
// one pass: it used to be computed per tab, reading every previous tab's
// offsetWidth again (O(N²) layout reads at each render of the tab bar).
export function calculateTabsOffsets(refs, spacing, count) {
  const tabs = Array.from(refs.map.values());
  const offsets = [0];

  for (let index = 1; index <= count; index++) {
    const tab = tabs[index - 1];
    const width =
      index - 1 < tabs.length ? (tab?.offsetWidth ?? 0) + spacing : 0;
    offsets.push(offsets[index - 1] + width);
  }

  return offsets;
}
